module.exports = __webpack_public_path__ + "img/image-024.c9f9b511.png";